var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppFilter',{ref:"appFilter",attrs:{"isPadding":true},on:{"apply":_vm.onFilter,"retainValues":_vm.retainFilter},model:{value:(_vm.filters),callback:function ($$v) {_vm.filters=$$v},expression:"filters"}})
}
var staticRenderFns = []

export { render, staticRenderFns }